<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4>Hallgatók listája</h4>
      <button 
        type="button" 
        class="btn btn-success"
        @click="exportToExcel"
        :disabled="exporting"
      >
        <span v-if="exporting" class="spinner-border spinner-border-sm me-2"></span>
        {{ exporting ? 'Exportálás...' : 'Excel export' }}
      </button>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="students.length === 0" class="text-center text-muted">
          Még nincsenek hallgatói adatok.
        </div>
        
        <div v-else class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Név</th>
                <th>E-mail</th>
                <th>Telefon</th>
                <th>Tanulmányok</th>
                <th>Szakirány</th>
                <th>Neptun</th>
                <th>Nyelvek</th>
                <th>Létrehozva</th>
                <th>Műveletek</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="student in students" :key="student.id">
                <td class="fw-bold">{{ student.full_name }}</td>
                <td>
                  <a v-if="student.email" :href="`mailto:${student.email}`">
                    {{ student.email }}
                  </a>
                  <span v-else class="text-muted">-</span>
                </td>
                <td>
                  <a v-if="student.phone" :href="`tel:${student.phone}`">
                    {{ student.phone }}
                  </a>
                  <span v-else class="text-muted">-</span>
                </td>
                <td>
                  <span v-if="student.education_level" class="badge bg-info">
                    {{ student.education_level }}
                  </span>
                  <span v-else class="text-muted">-</span>
                </td>
                <td>{{ student.major || '-' }}</td>
                <td>
                  <code v-if="student.neptun_code">{{ student.neptun_code }}</code>
                  <span v-else class="text-muted">-</span>
                </td>
                <td>
                  <div v-if="student.languages && student.languages.length">
                    <span 
                      v-for="lang in student.languages" 
                      :key="lang.language"
                      class="badge bg-secondary me-1"
                    >
                      {{ lang.language }} ({{ lang.level }})
                    </span>
                  </div>
                  <span v-else class="text-muted">-</span>
                </td>
                <td class="text-muted small">
                  {{ formatDate(student.created_at) }}
                </td>
                <td>
                  <div class="btn-group" role="group">
                    <button 
                      type="button" 
                      class="btn btn-sm btn-outline-primary"
                      @click="editStudent(student)"
                      title="Szerkesztés"
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <button 
                      type="button" 
                      class="btn btn-sm btn-outline-danger"
                      @click="deleteStudent(student)"
                      title="Törlés"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="mt-3 text-muted text-center">
      Összesen: {{ students.length }} hallgató
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import API_CONFIG from '../config/api.js'

export default {
  name: 'StudentList',
  props: {
    students: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      exporting: false
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleDateString('hu-HU') + ' ' + date.toLocaleTimeString('hu-HU')
    },
    async exportToExcel() {
      this.exporting = true
      try {
        const response = await axios.get(API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.EXPORT.EXCEL, {
          responseType: 'blob'
        })
        
        const blob = new Blob([response.data], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        })
        
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        
        const now = new Date()
        const timestamp = now.toISOString().slice(0, 10)
        link.download = `kaszk-hallgatok-${timestamp}.xlsx`
        
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Export error:', error)
        alert('Hiba történt az export során!')
      } finally {
        this.exporting = false
      }
    },
    editStudent(student) {
      this.$emit('edit-student', student)
    },
    deleteStudent(student) {
      if (confirm(`Biztosan törölni szeretné ${student.full_name} adatait?`)) {
        this.$emit('delete-student', student.id)
      }
    }
  }
}
</script>